/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export enum EAuthError {
  AUTH_BAD_CREDENTIALS = 'AUTH_BAD_CREDENTIALS',
  AUTH_INVALID_REFRESH_TOKEN = 'AUTH_INVALID_REFRESH_TOKEN',
  AUTH_INVALID_ACCESS_TOKEN = 'AUTH_INVALID_ACCESS_TOKEN',
  AUTH_NO_ACCESS_RIGHTS = 'AUTH_NO_ACCESS_RIGHTS',
  AUTH_EMAIL_ALREADY_EXISTS = 'AUTH_EMAIL_ALREADY_EXISTS',
  AUTH_RECENT_PASSWORD_CANNOT_BE_REUSED = 'AUTH_RECENT_PASSWORD_CANNOT_BE_REUSED',
  AUTH_INCORRECT_CURRENT_PASSWORD = 'AUTH_INCORRECT_CURRENT_PASSWORD',
  AUTH_USER_SESSION_CANNOT_BE_DELETED = 'AUTH_USER_SESSION_CANNOT_BE_DELETED',
  AUTH_INCORRECT_CONFIRMATION_CODE = 'AUTH_INCORRECT_CONFIRMATION_CODE',
  AUTH_INCORRECT_ACTIVATION_CODE = 'AUTH_INCORRECT_ACTIVATION_CODE',
  AUTH_USER_SESSION_NOT_FOUND = 'AUTH_USER_SESSION_NOT_FOUND',
  AUTH_INVALID_XSRF_TOKEN = 'AUTH_INVALID_XSRF_TOKEN',
}

export enum EFileError {
  FILE_EXPORT_UNAVAILABLE = 'FILE_EXPORT_UNAVAILABLE',
  FILE_CONVERT_TO_FILE_UNAVAILABLE = 'FILE_CONVERT_TO_FILE_UNAVAILABLE',
  FILE_CANNOT_BE_DELETED = 'FILE_CANNOT_BE_DELETED',
  FILE_ID_NOT_FOUND = 'FILE_ID_NOT_FOUND',
}

export enum EInvitationError {
  INVITATION_CANCELED = 'INVITATION_CANCELED',
  INVITATION_REGISTERED_CANNOT_BE_CHANGED = 'INVITATION_REGISTERED_CANNOT_BE_CHANGED',
  INVITATION_INCORRECT_TOKEN = 'INVITATION_INCORRECT_TOKEN',
  INVITATION_NOT_FOUND = 'INVITATION_NOT_FOUND',
}

export enum EOAuth2Error {
  OAUTH2UNSUPPORTED = 'OAUTH2_UNSUPPORTED',
  OAUTH2INCORRECTPROVIDER = 'OAUTH2_INCORRECT_PROVIDER',
  OAUTH2EMAILNOTFOUND = 'OAUTH2_EMAIL_NOT_FOUND',
}

export enum EPaymentError {
  PAYMENT_ERROR = 'PAYMENT_ERROR',
}

export enum EPlanError {
  PLAN_END_OF_SUBSCRIPTION_DATE = 'PLAN_END_OF_SUBSCRIPTION_DATE',
  PLAN_EXPIRED = 'PLAN_EXPIRED',
  PLAN_ID_NOT_FOUND = 'PLAN_ID_NOT_FOUND',
  PLAN_LIMIT_ID_NOT_FOUND = 'PLAN_LIMIT_ID_NOT_FOUND',
}

export enum EQrCodeError {
  QR_CODE_TYPE_NOT_AVAILABLE = 'QR_CODE_TYPE_NOT_AVAILABLE',
  QR_CODE_ALREADY_HAS_OWNER = 'QR_CODE_ALREADY_HAS_OWNER',
  QR_CODE_NOT_RELATED = 'QR_CODE_NOT_RELATED',
  QR_CODE_NOT_AVAILABLE = 'QR_CODE_NOT_AVAILABLE',
  QR_CODE_ID_NOT_FOUND = 'QR_CODE_ID_NOT_FOUND',
  QR_CODE_TEMPLATE_NOT_RELATED = 'QR_CODE_TEMPLATE_NOT_RELATED',
  QR_CODE_TEMPLATE_ID_NOT_FOUND = 'QR_CODE_TEMPLATE_ID_NOT_FOUND',
  QR_CODE_DESIGN_ID_NOT_FOUND = 'QR_CODE_DESIGN_ID_NOT_FOUND',
  QR_CODE_VCARD_ID_NOT_FOUND = 'QR_CODE_VCARD_ID_NOT_FOUND',
  QR_CODE_PDF_ID_NOT_FOUND = 'QR_CODE_PDF_ID_NOT_FOUND',
  QR_CODE_LOGO_ID_NOT_FOUND = 'QR_CODE_LOGO_ID_NOT_FOUND',
  QR_CODE_WEBSITE_ID_NOT_FOUND = 'QR_CODE_WEBSITE_ID_NOT_FOUND',
  QR_CODE_MULTILINK_ID_NOT_FOUND = 'QR_CODE_MULTILINK_ID_NOT_FOUND',
  QR_CODE_CANNOT_ASSIGN_TO_ANONYMOUS_USER = 'QR_CODE_CANNOT_ASSIGN_TO_ANONYMOUS_USER',
  QR_CODE_HAS_BEEN_DELETED = 'QR_CODE_HAS_BEEN_DELETED',
}

export enum ERestrictionError {
  MAX_LABELS_USED_RESTRICTION = 'MAX_LABELS_USED_RESTRICTION',
  MAX_QR_CODE_USED_RESTRICTION = 'MAX_QR_CODE_USED_RESTRICTION',
  PLAN_SUBSCRIPTION_RESTRICTION = 'PLAN_SUBSCRIPTION_RESTRICTION',
  PLAN_CREATION_QR_CODE_RESTRICTION = 'PLAN_CREATION_QR_CODE_RESTRICTION',
  PLAN_TEMPLATE_RESTRICTION = 'PLAN_TEMPLATE_RESTRICTION',
  PLAN_GPS_RESTRICTION = 'PLAN_GPS_RESTRICTION',
  PLAN_SCAN_RESTRICTION = 'PLAN_SCAN_RESTRICTION',
  PLAN_RESTRICTION = 'PLAN_RESTRICTION',
}

export enum ESubscriptionError {
  SUBSCRIPTION_ALREADY_CANCELED = 'SUBSCRIPTION_ALREADY_CANCELED',
  SUBSCRIPTION_CAN_NOT_RENEW = 'SUBSCRIPTION_CAN_NOT_RENEW',
  SUBSCRIPTION_DOES_NOT_EXISTED = 'SUBSCRIPTION_DOES_NOT_EXISTED',
  SUBSCRIPTION_NEED_TO_CANCEL_TO_CHANGE_CURRENCY = 'SUBSCRIPTION_NEED_TO_CANCEL_TO_CHANGE_CURRENCY',
  SUBSCRIPTION_CAN_NOT_DOWNGRADED = 'SUBSCRIPTION_CAN_NOT_DOWNGRADED',
  SUBSCRIPTION_STILL_ACTIVE = 'SUBSCRIPTION_STILL_ACTIVE',
  SUBSCRIPTION_ID_NOT_FOUND = 'SUBSCRIPTION_ID_NOT_FOUND',
}

export enum EUserError {
  USER_INCORRECT_CONFIRMATION_CODES = 'USER_INCORRECT_CONFIRMATION_CODES',
  USER_EMAIL_NOT_FOUND = 'USER_EMAIL_NOT_FOUND',
  USER_ID_NOT_FOUND = 'USER_ID_NOT_FOUND',
  USER_CANNOT_BE_ACTIVATED_OR_BANNED = 'USER_CANNOT_BE_ACTIVATED_OR_BANNED',
  USER_SETTING_NOT_FOUND = 'USER_SETTING_NOT_FOUND',
}

export interface Error {
  message: string;

  /** Base error code interface */
  errorCode: ErrorCode;
  args?: (object | null)[];
  template?: string | null;
}

/**
 * Base error code interface
 */
export type ErrorCode =
  | EPlanError
  | EAuthError
  | ERestrictionError
  | EQrCodeError
  | EOAuth2Error
  | EFileError
  | EUserError
  | ESubscriptionError
  | EInvitationError
  | EPaymentError;

export interface ErrorResponse {
  /** @format int64 */
  timestamp: number;

  /** @format int32 */
  status: number;
  errors: Error[];
}

export interface ErrorRestrictionResponse {
  /** @format int64 */
  timestamp: number;

  /** @format int32 */
  status: number;
  errors: Error[];
  errorCodes: ErrorCode[];
}

export interface EmailPreferenceSaveInDto {
  token: string;
  accountNotification: boolean;
  qrNotification: boolean;
  marketingNotification: boolean;
}

export interface EmailPreferenceInfoOutDto {
  email: string;
  accountNotification: boolean;
  qrNotification: boolean;
  marketingNotification: boolean;
}

export enum ECurrency {
  USD = 'USD',
  EUR = 'EUR',
  GBP = 'GBP',
}

export enum EPlanCycle {
  MONTHLY = 'MONTHLY',
  YEARLY = 'YEARLY',
}

export interface SubscriptionInDto {
  /** @format uuid */
  planId: string;
  planCycle: EPlanCycle;
  currency: ECurrency;
  successRedirectURL?: string;
  errorRedirectURL?: string;
}

export interface SubscriptionGatewayOutDto {
  url: string;
}

export interface DesignInDto {
  template?: TemplateInDto;

  /** @format uuid */
  libraryId?: string;

  /**
   * @format int32
   * @example 0
   */
  logoSize?: number;
  frameType: EFrameType;
  frameText?: string;

  /**
   * @format int32
   * @example 0
   */
  frameTextSize?: number;

  /** @example #000000 */
  frameTextColor: string;

  /** @example #000000 */
  frameBackgroundColor: string;

  /** @example #000000 */
  backgroundColor: string;
  patternType: EPatternType;
  cornerType: ECornerType;

  /** @example #000000 */
  patternColor: string;

  /** @example #000000 */
  cornerColor: string;
  reusable?: boolean;
}

/**
 * @example SQUARE
 */
export enum ECornerType {
  SQUARE = 'SQUARE',
  ROUNDED = 'ROUNDED',
  FULL_CIRCLE = 'FULL_CIRCLE',
}

/**
 * @example NONE
 */
export enum EFrameType {
  NONE = 'NONE',
  BORDER_LABEL_BOTTOM = 'BORDER_LABEL_BOTTOM',
  BORDER_LABEL_TOP = 'BORDER_LABEL_TOP',
  ARROW_LABEL_TOP = 'ARROW_LABEL_TOP',
  ARROW_LABEL_BOTTOM = 'ARROW_LABEL_BOTTOM',
  BORDER_SPACE_LABEL_BOTTOM = 'BORDER_SPACE_LABEL_BOTTOM',
  BORDER_SPACE_LABEL_TOP = 'BORDER_SPACE_LABEL_TOP',
  BORDER_INTERRUPTION = 'BORDER_INTERRUPTION',
  NO_BORDER = 'NO_BORDER',
  BORDER = 'BORDER',
}

/**
 * @example SQUARE
 */
export enum EPatternType {
  SQUARE = 'SQUARE',
  CLASSY = 'CLASSY',
  CLASSY_ROUNDED = 'CLASSY_ROUNDED',
  DOTS = 'DOTS',
  EXTRA_ROUNDED = 'EXTRA_ROUNDED',
  ROUNDED = 'ROUNDED',
}

export interface TemplateInDto {
  /** @example Title template */
  title: string;
}

export interface DesignOutDto {
  /** @format uuid */
  id: string;
  createdBy?: UserBaseOutDto;
  template?: TemplateOutDto;
  library?: LibraryOutDto;
  isReusable: boolean;

  /** @format int32 */
  logoSize: number;
  frameType: EFrameType;
  frameText?: string | null;

  /** @format int32 */
  frameTextSize: number;
  frameTextColor: string;
  frameBackgroundColor: string;
  backgroundColor: string;
  patternType: EPatternType;
  cornerType: ECornerType;
  patternColor: string;
  cornerColor: string;

  /** @format date-time */
  createdDate: string;
  reusable?: boolean;
}

export enum ELanguage {
  ENGLISH = 'ENGLISH',
  FRENCH = 'FRENCH',
  GERMAN = 'GERMAN',
  DUTCH = 'DUTCH',
  SPANISH = 'SPANISH',
  ITALIAN = 'ITALIAN',
}

export enum ELibraryType {
  DESIGN_LOGO = 'DESIGN_LOGO',
  MULTILINK_LOGO = 'MULTILINK_LOGO',
  VCARD_LOGO = 'VCARD_LOGO',
  LINK_LOGO = 'LINK_LOGO',
}

export enum ERole {
  ROLE_ADMIN = 'ROLE_ADMIN',
  ROLE_CUSTOMER = 'ROLE_CUSTOMER',
}

export enum EUserStatus {
  INACTIVE = 'INACTIVE',
  ACTIVE = 'ACTIVE',
  BANNED = 'BANNED',
  DELETED = 'DELETED',
}

export interface FileOutDto {
  /** @format uuid */
  id: string;
  fileName: string;

  /** @format date-time */
  createdDate: string;
}

export interface LibraryOutDto {
  /** @format uuid */
  id: string;
  file: FileOutDto;
  libraryType: ELibraryType;

  /** @format date-time */
  createdDate: string;
}

export interface TemplateOutDto {
  /** @format uuid */
  id: string;
  title: string;
  createdBy: UserBaseOutDto;

  /** @format date-time */
  createdDate: string;
}

export interface UserBaseOutDto {
  /** @format uuid */
  id: string;
  firstName?: string | null;
  lastName?: string | null;
  email: string;
  language: ELanguage;
  currency: ECurrency;

  /** @format int64 */
  totalCodes?: number;

  /** @format int64 */
  totalScans?: number;
  shouldAskForGPSCoordinates?: boolean;
  accountNotification?: boolean;
  qrNotification?: boolean;
  marketingNotification?: boolean;
  phone?: string | null;
  address?: string | null;
  birthDate?: string | null;
  role: ERole;

  /** @format uuid */
  avatarId?: string | null;
  company?: string | null;
  status: EUserStatus;

  /** @format date-time */
  createdDate: string;
}

export interface TemplateDeleteInDto {
  ids: string[];
}

export interface QrCodeMultiDeleteInDto {
  qrCodeIds: string[];
}

export interface QRCodeConnectInDto {
  generatedQRCodes?: string[];
}

export enum ECodeType {
  WEBSITE = 'WEBSITE',
  MULTILINK = 'MULTILINK',
  PDF = 'PDF',
  V_CARD = 'V_CARD',
}

export enum ELinkType {
  CUSTOM = 'CUSTOM',
  FACEBOOK = 'FACEBOOK',
  LINKEDIN = 'LINKEDIN',
  TIKTOK = 'TIKTOK',
  TELEGRAM = 'TELEGRAM',
  WHATSAPP = 'WHATSAPP',
  INSTAGRAM = 'INSTAGRAM',
  YOUTUBE = 'YOUTUBE',
  SKYPE = 'SKYPE',
  TWITTER = 'TWITTER',
}

export interface LinkOutDto {
  /** @format uuid */
  id: string;
  library?: LibraryOutDto;
  title: string;
  url: string;
  linkType: ELinkType;

  /** @format date-time */
  createdDate: string;
}

export interface MultilinkOutDto {
  /** @format uuid */
  id: string;
  library?: LibraryOutDto;
  title: string;
  description?: string;
  designBgColor: string;
  designTitleColor: string;
  designDescriptionColor: string;
  buttonBgColor: string;
  buttonTextColor: string;
  buttonHoverColor: string;
  buttonBorderColor: string;
  links: LinkOutDto[];

  /** @format date-time */
  createdDate: string;
}

export interface PDFOutDto {
  /** @format uuid */
  id: string;
  file: FileOutDto;

  /** @format date-time */
  createdDate: string;
}

export interface PageResponseQRCodeOutDto {
  result: QRCodeOutDto[];

  /** @format int64 */
  total: number;
}

export interface QRCodeOutDto {
  id: string;
  name: string;
  design?: DesignOutDto;
  createdBy?: UserBaseOutDto;
  shouldAskForGPSCoordinates: boolean;
  codeType: ECodeType;

  /** @format int64 */
  amountOfScans?: number | null;
  publicLogoType?: string | null;

  /** @format date-time */
  expireDate?: string | null;

  /** @format date-time */
  createdDate: string;
  website?: WebsiteOutDto;
  pdf?: PDFOutDto;
  multilink?: MultilinkOutDto;
  vcard?: VCardOutDto;
}

export interface VCardLinkOutDto {
  /** @format uuid */
  id: string;
  linkType: ELinkType;
  url: string;

  /** @format date-time */
  createdDate: string;
}

export interface VCardOutDto {
  /** @format uuid */
  id: string;
  library?: LibraryOutDto;
  fullName: string;
  phoneNumber: string;
  alternativePhoneNumber?: string | null;
  email: string;
  website: string;
  companyName: string;
  jobPosition: string;
  street: string;
  postalCode: string;
  city: string;
  state: string;
  country: string;
  designPrimaryColor: string;
  designSecondaryColor: string;
  designNameColor: string;
  designTitleColor: string;
  designTextColor: string;
  designIconColor: string;
  designTextHoverColor: string;
  buttonText: string;

  /** @format int32 */
  buttonSize: number;
  buttonBgColor: string;
  buttonTextColor: string;
  buttonHoverColor: string;
  buttonBorderColor: string;
  links: VCardLinkOutDto[];

  /** @format date-time */
  createdDate: string;
}

export interface WebsiteOutDto {
  /** @format uuid */
  id: string;
  url: string;

  /** @format date-time */
  createdDate: string;
}

export interface CustomerInDto {
  firstName: string;
  lastName: string;

  /** @example 12345678912 */
  phone?: string;

  /** @example Kharkiv, Ukraine */
  address?: string;

  /** @example 1991-10-17 */
  birthDate?: string;

  /** @format uuid */
  avatarId?: string;

  /** @example OSDB */
  company?: string;
  language?: ELanguage;
  currency?: ECurrency;
  shouldAskForGPSCoordinates: boolean;
  accountNotification: boolean;
  qrNotification: boolean;
  marketingNotification: boolean;
}

export interface CustomerSubscriptionOutDto {
  planType: EPlanType;
  planStatus: EPlanStatus;
  currency: ECurrency;
  planCycle?: EPlanCycle;

  /** @format date-time */
  startOfSubscriptionDate: string;

  /** @format date-time */
  endOfSubscriptionDate: string;
}

export enum EPlanStatus {
  ACTIVE = 'ACTIVE',
  CANCELED = 'CANCELED',
}

export enum EPlanType {
  TRIAL = 'TRIAL',
  BASIC = 'BASIC',
  STARTER = 'STARTER',
  PREMIUM = 'PREMIUM',
}

export enum ESettingType {
  AUTH2FA = 'AUTH_2FA',
}

export interface PlanDetailsOutDto {
  planType: EPlanType;
  planStatus: EPlanStatus;

  /** @format date-time */
  endOfCurrentSubscription: string;

  /** @format int32 */
  amountMaxQrCodes: number;

  /** @format int32 */
  amountMaxScans?: number | null;
  hasTemplates: boolean;
  hasLabels: boolean;
  hasRealTimeDataDashboard: boolean;
  hasTrackScanTimeOfDay: boolean;
  hasTrackScanLocation: boolean;
  hasTrackScanDevice: boolean;
  hasTrackScanGPS: boolean;
  hasQrDesignCustomisations: boolean;
  hasBulkQrCodeGeneration: boolean;

  /** @format int32 */
  amountOfMaxBulkQrCode: number;
  gdprCompliant: boolean;
  ccpaCompliant: boolean;
  knowledgeBase: boolean;
  emailSupport: boolean;
  dedicatedCustomerSuccessManager: boolean;
}

export interface PlanUserOutDto {
  /** @format uuid */
  id: string;
  name: string;
  price?: PriceOutDto;

  /** @format date-time */
  createdDate: string;
}

export interface PriceOutDto {
  /** @format uuid */
  id?: string | null;

  /** @format double */
  price?: number | null;
  planCycle?: EPlanCycle;
  planCurrency: ECurrency;

  /** @format date-time */
  createdDate?: string | null;
}

export interface UserOutDto {
  /** @format uuid */
  id: string;
  firstName?: string | null;
  lastName?: string | null;
  email: string;
  language: ELanguage;
  currency: ECurrency;

  /** @format int64 */
  totalCodes?: number;

  /** @format int64 */
  totalScans?: number;
  shouldAskForGPSCoordinates?: boolean;
  accountNotification?: boolean;
  qrNotification?: boolean;
  marketingNotification?: boolean;
  phone?: string | null;
  address?: string | null;
  birthDate?: string | null;
  role: ERole;

  /** @format uuid */
  avatarId?: string | null;
  company?: string | null;
  subscription?: CustomerSubscriptionOutDto;
  status: EUserStatus;

  /** @format date-time */
  createdDate: string;
  settings: UserSettingOutDto[];
  plan?: PlanUserOutDto;
  currentPlanDetails?: PlanDetailsOutDto;

  /** @format date-time */
  stripeSyncedDate?: string | null;
}

export interface UserSettingOutDto {
  /** @format uuid */
  id: string;
  type: ESettingType;
  isEnabled: boolean;
}

export interface AdminInDto {
  firstName: string;
  lastName: string;

  /** @example 12345678912 */
  phone?: string;

  /** @example Kharkiv, Ukraine */
  address?: string;

  /** @example 1991-10-17 */
  birthDate?: string;

  /** @format uuid */
  avatarId?: string;
  language?: ELanguage;
}

export interface AdminOutDto {
  /** @format uuid */
  id: string;
  firstName: string;
  lastName: string;
  email: string;
  language: ELanguage;
  phone?: string;
  address?: string;
  birthDate?: string;
  role: ERole;

  /** @format uuid */
  avatarId?: string;
  status: EUserStatus;

  /** @format date-time */
  createdDate: string;
}

export interface GeoDetailsInDto {
  /** @format double */
  lat: number;

  /** @format double */
  lng: number;

  /** @format double */
  accuracy?: number;
}

export interface ScanInDto {
  /** @format uuid */
  deviceId: string;
  gps?: GeoDetailsInDto;
}

export type CodeInDto = object;

export interface LinkInDto {
  /** @format uuid */
  libraryId?: string;
  title: string;
  url: string;
  linkType: ELinkType;
}

export interface MultilinkInDto {
  /** @format uuid */
  libraryId?: string;
  title: string;
  description?: string;
  designBgColor: string;
  designTitleColor: string;
  designDescriptionColor: string;
  buttonBgColor: string;
  buttonTextColor: string;
  buttonHoverColor: string;
  buttonBorderColor: string;
  links: LinkInDto[];
}

export interface PDFInDto {
  /** @format uuid */
  fileId?: string;
}

export interface QRCodeInDto {
  /** @example Name qr code */
  name: string;
  design?: DesignInDto;

  /** @format uuid */
  templateId?: string;
  codeType: ECodeType;
  publicLogoType?: string;
  website?: WebsiteInDto;
  pdf?: PDFInDto;
  multilink?: MultilinkInDto;
  vcard?: VCardInDto;
  codeDto?: CodeInDto;
}

export interface VCardInDto {
  /** @format uuid */
  libraryId?: string;
  fullName: string;
  phoneNumber: string;
  alternativePhoneNumber?: string;
  email?: string;
  website?: string;
  companyName?: string;
  jobPosition?: string;
  street?: string;
  postalCode?: string;
  city?: string;
  state?: string;
  country?: string;
  designPrimaryColor: string;
  designSecondaryColor: string;
  designNameColor: string;
  designTitleColor: string;
  designTextColor: string;
  designIconColor: string;
  designTextHoverColor: string;
  buttonText: string;

  /** @format int32 */
  buttonSize: number;
  buttonBgColor: string;
  buttonTextColor: string;
  buttonHoverColor: string;
  buttonBorderColor: string;
  links?: VCardLinkInDto[];
}

export interface VCardLinkInDto {
  linkType: ELinkType;
  url: string;
}

export interface WebsiteInDto {
  url: string;
}

export interface LibraryInDto {
  fileIds?: string[];
  libraryType?: ELibraryType;
}

export interface PageResponseLibraryOutDto {
  result: LibraryOutDto[];

  /** @format int64 */
  total: number;
}

/**
 * @example COOKIE
 */
export enum EAuthType {
  COOKIE = 'COOKIE',
  TOKEN = 'TOKEN',
}

export interface SignUpInDto {
  /** @example ssmith@osdb.io */
  email: string;
  language: ELanguage;
  autoLinkQRID?: string;
  authType?: EAuthType;
}

export interface AuthOutDto {
  /** @format uuid */
  id: string;
  firstName?: string | null;
  lastName?: string | null;
  email: string;
  language: ELanguage;
  currency: ECurrency;

  /** @format int64 */
  totalCodes?: number;

  /** @format int64 */
  totalScans?: number;
  shouldAskForGPSCoordinates?: boolean;
  accountNotification?: boolean;
  qrNotification?: boolean;
  marketingNotification?: boolean;
  phone?: string | null;
  address?: string | null;
  birthDate?: string | null;
  role: ERole;

  /** @format uuid */
  avatarId?: string | null;
  company?: string | null;
  status: EUserStatus;

  /** @format date-time */
  createdDate: string;
  settings: UserSettingOutDto[];
  plan?: PlanUserOutDto;
  currentPlanDetails?: PlanDetailsOutDto;

  /** @format date-time */
  stripeSyncedDate?: string | null;
  accessToken?: string | null;
  refreshToken?: string | null;
}

export interface SignInStepOneInDto {
  /** @example okogutenko+client@osdb.io */
  email: string;

  /** @example okogutenko+client@osdb.io */
  password: string;
  authType?: EAuthType;
}

export interface SignInStepTwoInDto {
  /** @example dberchiyan@osdb.io */
  email: string;
  confirmCode: string;
  authType?: EAuthType;
}

export interface UpdateTokensInDto {
  refreshToken: string;
}

export interface AuthTokensOutDto {
  accessToken: string;
  refreshToken: string;
}

export interface InvitationSignUpInDto {
  /** @format uuid */
  invitationToken: string;
  password: string;
  firstName: string;
  lastName: string;

  /** @example 12345678912 */
  phone?: string;

  /** @example Kharkiv, Ukraine */
  address?: string;

  /** @example 1991-10-17 */
  birthDate?: string;

  /** @example OSDB */
  company?: string;
  language: ELanguage;
  authType?: EAuthType;
}

export interface ResetPasswordInDto {
  /** @example dberchiyan@osdb.io */
  email: string;
  confirmCode: string;

  /** @example dberchiyan@osdb.io */
  newPassword: string;
}

export interface ForgotPasswordInDto {
  /** @example dberchiyan@osdb.io */
  email: string;
}

export interface InviteInDto {
  email: string;

  /**
   * @pattern ROLE_CUSTOMER
   * @example ROLE_CUSTOMER
   */
  role?: string;
}

export interface UserStatusInDto {
  /**
   * @pattern ACTIVE|BANNED|DELETED
   * @example ACTIVE
   */
  status: string;
}

export interface InvitationStatusInDto {
  /**
   * @pattern PENDING|CANCELED
   * @example PENDING
   */
  status: string;
}

export interface ChangePasswordInDto {
  /** @example dberchiyan@osdb.io */
  newPassword: string;

  /** @example dberchiyan@osdb.io */
  confirmNewPassword: string;
}

export interface CEStepTwoInDto {
  currEmailConfirmCode: string;
  newEmailConfirmCode: string;
}

export interface CEStepOneInDto {
  newEmail: string;
}

export interface TwoFAStepTwoInDto {
  confirmCode: string;
  isEnabled: boolean;
}

export interface QrCodeAdminInDto {
  /** @format uuid */
  createdById?: string;
  isDeleted?: boolean;
}

export interface QRCodeAdminOutDto {
  id: string;
  name: string;
  isDeleted: boolean;
  design?: DesignOutDto;
  createdBy?: UserBaseOutDto;
  shouldAskForGPSCoordinates: boolean;
  codeType: ECodeType;

  /** @format int64 */
  amountOfScans?: number | null;
  publicLogoType?: string | null;

  /** @format date-time */
  expireDate?: string | null;

  /** @format date-time */
  createdDate: string;
  website?: WebsiteOutDto;
  pdf?: PDFOutDto;
  multilink?: MultilinkOutDto;
  vcard?: VCardOutDto;

  /** @format date-time */
  deletedDate?: string | null;
}

export enum EInvitationStatus {
  PENDING = 'PENDING',
  CANCELED = 'CANCELED',
  REGISTERED = 'REGISTERED',
}

export interface PageResponseUserInvitationOutDto {
  result: UserInvitationOutDto[];

  /** @format int64 */
  total: number;
}

export interface UserInvitationOutDto {
  /** @format uuid */
  id: string;
  email: string;

  /** @format uuid */
  token: string;
  role: ERole;
  status: EInvitationStatus;

  /** @format date-time */
  createdDate: string;

  /** @format uuid */
  invitedBy: string;
}

export enum ESubscriptionStatus {
  ACTIVE = 'ACTIVE',
  PAST_DUE = 'PAST_DUE',
  UNPAID = 'UNPAID',
  CANCELED = 'CANCELED',
  INCOMPLETE = 'INCOMPLETE',
  INCOMPLETE_EXPIRED = 'INCOMPLETE_EXPIRED',
  TRIALING = 'TRIALING',
  PAUSED = 'PAUSED',
}

export interface PlanSubscriptionOutDto {
  /** @format uuid */
  id: string;
  name: string;
  price: PriceOutDto;

  /** @format date-time */
  createdDate: string;
}

export interface SubscriptionOutDto {
  /** @format uuid */
  id?: string | null;
  subscription: PlanSubscriptionOutDto;
  status: ESubscriptionStatus;

  /** @format date-time */
  createdDate?: string | null;
}

export enum EInvoiceStatus {
  SUCCESS = 'SUCCESS',
  FAILED = 'FAILED',
}

export interface InvoiceOutDto {
  name?: string;

  /** @format date-time */
  date?: string;
  planType?: EPlanType;
  status?: EInvoiceStatus;

  /** @format int64 */
  amount?: number;
  urlInvoice?: string;
}

export interface PageResponseInvoiceOutDto {
  result: InvoiceOutDto[];

  /** @format int64 */
  total: number;
}

export interface PageResponseScanOutDto {
  result: ScanOutDto[];

  /** @format int64 */
  total: number;
}

export interface ScanOutDto {
  /** @format uuid */
  id: string;

  /** @format uuid */
  deviceId: string;
  qrCodeId: string;
  ip: string;
  country?: string | null;
  region?: string | null;
  city?: string | null;

  /** @format double */
  latitude?: number | null;

  /** @format double */
  longitude?: number | null;
  providerOrg?: string | null;
  timeZone?: string | null;
  operationSystem?: string | null;
  deviceType?: string | null;
  browserName?: string | null;
  browserType?: string | null;
  browserVersion?: string | null;

  /** @format date-time */
  createdDate: string;
}

export interface PageResponseDesignOutDto {
  result: DesignOutDto[];

  /** @format int64 */
  total: number;
}

export interface DisabledReasonsOutDto {
  reasonCode?: ERestrictionError[];
}

export interface PageResponsePlanOutDto {
  result: PlanOutDto[];

  /** @format int64 */
  total: number;
}

export interface PlanLimitOutDto {
  planType: EPlanType;

  /** @format int32 */
  amountMaxQrCodes: number;

  /** @format int32 */
  amountMaxScans?: number | null;
  hasTemplates: boolean;
  hasLabels: boolean;
  hasRealTimeDataDashboard: boolean;
  hasTrackScanTimeOfDay: boolean;
  hasTrackScanLocation: boolean;
  hasTrackScanDevice: boolean;
  hasTrackScanGPS: boolean;
  hasQrDesignCustomisations: boolean;
  hasBulkQrCodeGeneration: boolean;

  /** @format int32 */
  amountOfMaxBulkQrCode: number;
  gdprCompliant: boolean;
  ccpaCompliant: boolean;
  knowledgeBase: boolean;
  emailSupport: boolean;
  dedicatedCustomerSuccessManager: boolean;
}

export interface PlanOutDto {
  /** @format uuid */
  id: string;
  name: string;
  type: EPlanType;
  prices: PriceOutDto[];
  planLimit: PlanLimitOutDto;
  disabledReasons?: DisabledReasonsOutDto;

  /** @format date-time */
  createdDate: string;
}

export interface DashboardOutDto {
  /** @format int64 */
  totalQRCodes: number;

  /** @format int64 */
  totalScans: number;

  /** @format int64 */
  totalUsers: number;
}

export enum ESubscriptionAdminStatus {
  ACTIVE = 'ACTIVE',
  CANCELED_NOT_EXPIRED = 'CANCELED_NOT_EXPIRED',
  EXPIRED = 'EXPIRED',
}

export interface CustomerAdminOutDto {
  /** @format uuid */
  id: string;
  firstName?: string | null;
  lastName?: string | null;
  email?: string | null;
  deletedEmail?: string | null;
  language: ELanguage;
  currency: ECurrency;

  /** @format int64 */
  totalCodes?: number;

  /** @format int64 */
  totalScans?: number;
  shouldAskForGPSCoordinates?: boolean;
  accountNotification?: boolean;
  qrNotification?: boolean;
  marketingNotification?: boolean;
  phone?: string | null;
  address?: string | null;
  birthDate?: string | null;
  role: ERole;

  /** @format uuid */
  avatarId?: string | null;
  company?: string | null;
  subscription: CustomerSubscriptionOutDto;
  status: EUserStatus;

  /** @format date-time */
  stripeSyncedDate?: string | null;

  /** @format date-time */
  deletedDate?: string | null;

  /** @format date-time */
  createdDate: string;
}

export interface PageResponseCustomerAdminOutDto {
  result: CustomerAdminOutDto[];

  /** @format int64 */
  total: number;
}

export interface UserSettingListOutDto {
  settings: UserSettingOutDto[];
}

export interface UserSessionListOutDto {
  sessions: UserSessionOutDto[];
}

export interface UserSessionOutDto {
  /** @format uuid */
  id: string;
  ipAddress: string;
  platform: string;
  isCurrent: boolean;

  /** @format date-time */
  createdDate: string;
}

export interface PageResponseAdminOutDto {
  result: AdminOutDto[];

  /** @format int64 */
  total: number;
}

export interface PageResponseQRCodeAdminOutDto {
  result: QRCodeAdminOutDto[];

  /** @format int64 */
  total: number;
}
